import { EntityService } from "../services/entityService";
import { useMemo } from "react";

export const useEntityCrud = (entityName) => {

    const service = useMemo(() => new EntityService(entityName), [entityName])


    const readData = (body) => {
        return service.read(body)
    }

    const readDataGet = (body) => {
        return service.readGet(body)
    }

    const readDataOnly = (body) => {
        return service.readOnly(body)
    }

    const readDataById = (id) => {
         
        return service.readById(id)
    }

    const readGetDataById = () => {        
        return service.readGetById()
    }
    

    const readDataByFilter = (filter) => {        
        return service.readByFilter(filter)
    }

    const readGetDataByFilter = (filter) => {    
             
        return service.readGetByFilter(filter)
    }

    const addData = (body) => {
        return service.add(body)
    }

    const addDataGet = (body) => {
        return service.addGet(body)
    }

    const updateDate = (body) => {        
        return service.update(body)
    }

    const deleteData = (id) => {
        return service.delete(id)
    }


    const statusData = (body) => {        
        return service.status(body)
    }

    return {
        readData,
        readDataGet,
        addData,
        addDataGet,
        readDataById,
        readGetDataById,
        updateDate,
        statusData,
        readDataByFilter,
        readGetDataByFilter,
        deleteData,
        readDataOnly
    }
}
